export const AUDIO_DESCRIPTION = "audio description";
export const AUDIO_DUBBING = "audio dubbing";

const AUDIO_GROUP_TYPES = [AUDIO_DESCRIPTION, AUDIO_DUBBING];
const ORIGINAL_TEXT_TYPES = ["translation", AUDIO_DUBBING];

export function isAudioGroupType(type) {
    return AUDIO_GROUP_TYPES.includes(type);
}

export function hasOriginalText(type) {
    return ORIGINAL_TEXT_TYPES.includes(type);
}
